/** Sistem dipercayai dan rujukan luar (Fasa 2 P2-4): di sebelah import-ms.ts. */
export default {
  trustedSystems: {
    title: 'Sistem dipercayai',
    description:
      'Pakej kes yang ditandatangani oleh sistem ini diterima sebagai milik mereka. Setiap sistem menerbitkan kunci tandatangannya sebagai senarai kunci.',
    empty: 'Belum ada sistem dipercayai.',
    add: 'Tambah sistem dipercayai',
    edit: 'Sunting',
    remove: 'Buang',
    removeConfirm: 'Buang {{system}}? Pakejnya tidak lagi akan disahkan di sini.',
    confirmRemove: 'Buang sistem',
    cancel: 'Batal',
    save: 'Simpan',
    saved: 'Sistem dipercayai telah disimpan.',
    dialogTitle: 'Sistem dipercayai',
    systemId: 'Id sistem',
    systemIdTaken: 'Sistem dipercayai dengan id ini sudah wujud: suntingnya sahaja.',
    systemIdHint:
      'Nama pendek anda sendiri untuk sistem ini, dalam huruf kecil, contohnya mbjb-osc. Serahan hadapan menamakannya.',
    name: 'Nama',
    keySource: 'Kunci tandatangan',
    keySourceUrl: 'Ambil daripada alamat senarai kunci sistem',
    keySourceJwks: 'Tampal senarai kunci',
    jwksUrl: 'Alamat senarai kunci',
    jwksUrlHint: 'Alamat https yang diberikan oleh sistem, contohnya alamat /planning/jwks miliknya.',
    jwks: 'Senarai kunci (JSON)',
    jwksHint: 'Fail senarai kunci yang dihantar oleh sistem kepada anda.',
    jwksAgain: 'Tampal senarai kunci sekali lagi: ia diganti sepenuhnya apabila anda menyimpan.',
    requireSeal: 'Wajibkan pakej bertandatangan bagi serahan yang dipegang oleh sistem ini',
    kids: 'Id kunci',
    withheldKids:
      'Ditahan: {{kids}}. Sistem dipercayai lain turut menerbitkan kunci ini, jadi entri ini tidak mengesahkan dengannya. Simpan entri ini untuk menuntutnya, jika ia miliknya.',
    fetchedAt: 'Kunci diambil {{date}}',
    importTitle: 'Pakej yang diimport',
    importRequireSeal: 'Tolak pakej yang tidak ditandatangani oleh sistem dipercayai',
    importRequireSealHint:
      'Hidup secara lalai. Pakej yang tidak ditandatangani, atau ditandatangani dengan kunci yang tidak diterbitkan oleh mana-mana sistem dipercayai anda, ditolak. Apabila dimatikan, pakej sedemikian diimport sebagai salinan baca sahaja yang tidak boleh dikemas kini, dengan amaran; ia tidak sekali-kali mengambil alih serahan.',
    importRequireSealOff:
      'Pakej yang tidak ditandatangani oleh mana-mana sistem dipercayai akan diterima sebagai salinan baca sahaja. Semak asal-usul pakej sebelum anda mengimportnya.',
    ruleOn:
      'Setiap pakej yang diimport mesti ditandatangani oleh salah satu sistem ini (Pakej yang diimport, di atas).',
    ruleOff:
      'Pakej yang tidak ditandatangani oleh sistem ini diimport sebagai salinan baca sahaja, kecuali jika sistem yang memegang serahan itu memerlukan pakej bertandatangan (Pakej yang diimport, di atas).',
    ruleOnEmpty:
      'Belum ada sistem dipercayai: selagi “Tolak pakej yang tidak ditandatangani oleh sistem dipercayai” dihidupkan, setiap pakej yang diimport ditolak.',
    reasons: {
      body: 'Semak medan dan cuba lagi.',
      system_id:
        'Gunakan huruf kecil, digit, sengkang atau garis bawah; “unverified”, “constructor” dan “prototype” dikhaskan.',
      name: 'Masukkan nama sehingga 200 aksara.',
      key_source: 'Berikan sama ada alamat senarai kunci atau senarai kunci yang ditampal, bukan kedua-duanya.',
      jwks: 'Senarai kunci bukan senarai kunci awam Ed25519 yang sah.',
      private_key: 'Senarai kunci memegang kunci persendirian. Tampal kunci awam sahaja.',
      kid_mismatch: 'Satu id kunci tidak sepadan dengan kuncinya.',
      kid_taken: 'Sistem dipercayai lain sudah menggunakan salah satu kunci ini.',
      limit: 'Anda boleh mempercayai paling banyak 100 sistem.',
      jwks_url_invalid: 'Alamat mestilah alamat https tanpa nama pengguna.',
      jwks_url_blocked: 'Alamat itu tidak boleh diambil dari sini.',
      jwks_unreachable: 'Senarai kunci tidak dapat diambil.',
      jwks_too_large: 'Senarai kunci terlalu besar.',
      jwks_invalid: 'Alamat itu tidak memulangkan senarai kunci yang sah.',
    },
  },
  externalIds: {
    title: 'Rujukan luar',
    intro:
      'Id yang diberikan oleh sistem lain kepada serahan ini, contohnya id permohonan OSC (osc3plus:id_permohonan).',
    empty: 'Tiada rujukan luar.',
    scheme: 'Skema',
    schemeHint: 'Jenis id, contohnya osc3plus:id_permohonan atau osc3plus:id_projek.',
    issuer: 'Dikeluarkan oleh',
    value: 'Id rujukan',
    link: 'Pautkan rujukan',
    linked: 'Rujukan telah dipautkan.',
    imported: 'daripada import',
    origin: 'Diimport daripada {{system}} (rujukan mereka {{ref}}).',
    originUnverified: 'Diimport daripada sistem yang tidak disahkan (rujukan mereka {{ref}}).',
  },
}
